import React from 'react';
import styles from './index.module.css';

export const Textarea = React.forwardRef((
  { 
    children, 
    id, 
    value, 
    label, 
    rows = 4, // Default height of 4 rows
    ...props 
  }, ref) => {

    return (
      <div className={styles.textarea}>
        {label && <label htmlFor={id} className={styles.label}>{label}</label>}
        <textarea 
          id={id} 
          value={value} 
          ref={ref} 
          className={styles.field}
          rows={rows}
          {...props}
        />
      </div>
    )
  }
); 